'use strict';

const RequestReference = require('../rlink-data-connector/storage/RequestReference');
const reference = require('../rlink-data-connector/reference');
const arrayShape = require('../rlink-shapes/arrayShape');
const validate = require('../rlink-shapes/validate');

module.exports = class Request {
  constructor (type, name, {emptyValue = null}, argSpec) {
    this.type = type;
    this.name = name;
    this.argSpec = arrayShape(argSpec);
    this.emptyValue = emptyValue;
  }

  keyFor (...requestArgs) {
    this.validateArgs(...requestArgs);
    return `${this.type.typeName}.${this.name}(${requestArgs.map(JSON.stringify).join(', ')})`;
  }

  referenceFor (...requestArgs) {
    this.validateArgs(...requestArgs);
    return reference(this, ...requestArgs);
  }

  boundArgMapping (mapper) {
    return (...args) => [this, ...mapper(...args)];
  }

  validateArgs (...requestArgs) {
    validate(requestArgs, this.argSpec, `${this.type.typeName}.${this.name}.requestArgs`);
  }

  toString () {
    return `Request(${this.type.typeName || this.type.name}.${this.name})`;
  }

  getReferenceType () {
    return RequestReference;
  }
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/Request.js